import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'group'
})
export class GroupPipe implements PipeTransform {
  transform(collection, property: string) {
    let groupByInfluencerType = {};
    if (collection) {
      collection.forEach(function(influencer) {
        groupByInfluencerType[influencer[property]] =
          groupByInfluencerType[influencer[property]] || [];
        groupByInfluencerType[influencer[property]].push(influencer);
      });
    }
    return groupByInfluencerType;
  }
}
